import APIConfiguration from '@savgroup-front-common/configuration/api';
import { COMMON_QUERY_PARAMS } from '@savgroup-front-common/constants';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.workflow}files/${COMMON_QUERY_PARAMS.FILE_ID}/states`;

export interface FileStateHistoryModuleSummary {
  id?: string;
  definitionId?: string;
  wave: number;
  parameters?: {
    [key: string]: string;
  };
  referencedModuleType?: string;
}

export interface StateSummary {
  name?: string;
  shortLabel?: string;
  label?: string;
}

export interface FileStateHistorySummary {
  fileId: string;
  module: FileStateHistoryModuleSummary;
  stateDate: Date;
  state: StateSummary;
  comment?: string;
  toCustomerComment?: string;
  duration?: Date;
  responsible: {
    userId: string;
    fullname?: string;
  };
}

export interface GetFileStatesQueryArgs {
  fileId: string;
}

type GetFileStatesQuery = (
  payload: GetFileStatesQueryArgs,
) => Promise<
  BackResponse<FileStateHistorySummary[] | undefined> | BackResponseFailure
>;

export const getFileStatesRequest = (
  payload: GetFileStatesQueryArgs,
): ApiRequestDescriptor => ({
  url: ENDPOINT.replace(COMMON_QUERY_PARAMS.FILE_ID, payload.fileId),
  config: { method: SUPPORTED_METHODS.GET },
});

const getFileStatesQuery: GetFileStatesQuery = async (payload) => {
  try {
    return await executeQuery<
      BackResponse<FileStateHistorySummary[] | undefined>
    >(getFileStatesRequest(payload));
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
};

export default getFileStatesQuery;
